import { render, staticRenderFns } from "@/templates/document/transitionLetter.html?vue&type=template&id=76cd495a&scoped=true&"
import script from "./TransitionLetter.vue?vue&type=script&lang=js&"
export * from "./TransitionLetter.vue?vue&type=script&lang=js&"
import style0 from "./TransitionLetter.vue?vue&type=style&index=0&id=76cd495a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd495a",
  null
  
)

export default component.exports